<template>
  <v-card class="px-3 pt-2 pb-3 mb-2">
    <v-card
      flat
      tile
      class="py-1 px-2 d-flex align-center justify-space-between"
    >
      <div class="d-flex align-center flex-grow-1">
        <div class="font-weight-bold text-body-2">
          <span class="grey--text darken-3 mr-2">{{ $t('m.ttlVoyDays') }}:</span>
          <span>{{ ttlVoyDays }}</span>
        </div>
        <div class="text-body-2 ml-4">
          <span class="pl-0 ml-0">
            <span class="grey--text darken-3 mr-1">{{ $t('m.ttlSeaDays') }}:</span>
            <span class="font-weight-bold">{{ ttlSeaDays }}</span>
          </span>
          <span class="ml-3">
            <span class="grey--text darken-3 mr-1">{{ $t('m.ttlPortIdleDays') }}:</span>
            <span class="font-weight-bold">{{ ttlPortIdleDays }}</span>
          </span>
          <span class="ml-3">
            <span class="grey--text darken-3 mr-1">{{ $t('m.ttlPortWorkDays') }}:</span>
            <span class="font-weight-bold">{{ ttlPortWorkDays }}</span>
          </span>
        </div>
      </div>
      <div class="">
        <v-btn
          depressed
          color="primary"
          small
          @click="openMap"
          :disabled="openMapDisabled"
        >
          {{ $t('m.openMap') }}
        </v-btn>
      </div>
    </v-card>

    <v-card
      flat
      tile
      class=""
      style="height:170px;"
    >
      <v-simple-table
        dense
        fixed-header
        class="my-simple-table"
        style="max-height:170px; overflow-y:auto;"
      >
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-center">
                #
              </th>
              <th class="text-center">
                {{ $t('m.taskTypeName') }}
              </th>
              <th class="text-center">
                {{ $t('m.port') }}
              </th>
              <th class="text-center">
                {{ $t('m.distance') }}
              </th>
              <th class="text-center">
                {{ $t('m.seaDays') }}
              </th>
              <th class="text-center">
                {{ $t('m.idleDays') }}
              </th>
              <th class="text-center">
                {{ $t('m.workDays') }}
              </th>
              <th class="text-center">
                {{ $t('m.portCharge') }}
              </th>
              <th class="text-center">
                {{ $t('m.arrivedDate') }}
              </th>
              <th class="text-center">
                {{ $t('m.departed') }}
              </th>
            </tr>
          </thead>
          <tbody>
            <template v-for="(item, index) in portsRotationArr">
              <tr>
                <td width="9%">
                  <v-row
                    dense
                    justify="center"
                  >
                    <v-btn
                      x-small
                      icon
                      v-if="item.portSeqInCargos==-1&&item.taskType!==''"
                      :disabled="isGettedDistance"
                      @click="removePortPad(index)"
                    >
                      <v-icon small>
                        mdi-close
                      </v-icon>
                    </v-btn>

                    <v-btn
                      x-small
                      icon
                      @click="moveRow(index, 'UP')"
                      v-if="index > 0 && portsRotationArr.length>2
                        && item.portSeqInCargos==-1 && item.taskType!==''"
                      :disabled="isGettedDistance"
                    >
                      <v-icon small>
                        mdi-arrow-up-bold-outline
                      </v-icon>
                    </v-btn>
                    <v-btn
                      x-small
                      icon
                      @click="moveRow(index, 'DOWN')"
                      v-if="index < (portsRotationArr.length - 1) && portsRotationArr.length>2
                        && item.portSeqInCargos==-1 && item.taskType!==''"
                      :disabled="isGettedDistance"
                    >
                      <v-icon small>
                        mdi-arrow-down-bold-outline
                      </v-icon>
                    </v-btn>
                  </v-row>
                </td>
                <td width="8%">
                  <div class="text-caption">
                    {{ item.taskTypeName }}
                  </div>
                </td>
                <td>
                  <div class="text-caption">
                    {{ item.port.portName }}
                  </div>
                </td>
                <td width="9%">
                  {{ item.distance }}
                </td>
                <td width="7%">
                  {{ item.seaDays }}
                </td>
                <td width="7%">
                  <v-text-field
                    dense
                    hide-details
                    text-center
                    :value="item.idleDays"
                    v-model="item.idleDays"
                    style="font-size:12px;"
                    @input="val => handleFieldInput(val, index, 'IDLEDAYS')"
                    class="mb-1 mt-0"
                  />
                </td>
                <td width="7%">
                  <v-text-field
                    dense
                    hide-details
                    text-center
                    @input="val => handleFieldInput(val, index, 'WORKDAYS')"
                    v-model="item.workDays"
                    :value="item.workDays"
                    class="mb-1 mt-0 text-caption"
                  />
                </td>
                <td width="9%">
                  <v-text-field
                    dense
                    hide-details
                    @input="val => handleFieldInput(val, index, 'PORTCHARGE')"
                    v-model="item.portCharge"
                    :value="item.portCharge"
                    class="mb-1 mt-0 text-caption"
                  />
                </td>
                <td
                  width="14%"
                  class="text-caption"
                >
                  <template v-if="index==0 && isRotating">
                    <template v-if="myArrivedDate && myArrivedTime">
                      <v-btn
                        x-small
                        text
                        class="px-0"
                        color="green"
                        @click="openDateAndTimeDlg"
                      >
                        <span>{{ myArrivedDateDisplay + ' ' + myArrivedTime }}</span>
                      </v-btn>
                    </template>
                    <template v-else>
                      <v-btn
                        x-small
                        text
                        class="px-0"
                        color="green"
                        @click="openDateAndTimeDlg"
                      >
                        <v-icon small>
                          mdi-calendar
                        </v-icon>
                        <span>Select</span>
                      </v-btn>
                    </template>
                  </template>
                  <template v-else>
                    {{ item.arrived | timFormat }}
                  </template>
                </td>
                <td
                  width="14%"
                  class="text-caption"
                >
                  {{ item.departed | timFormat }}
                </td>
              </tr>
            </template>
          </tbody>
        </template>
      </v-simple-table>
    </v-card>
    <v-card class="mt-2 py-1 px-2 d-flex align-center">
      <template v-if="isRotating">
        <v-btn
          depressed
          color="warning"
          small
          @click="genPortRotation"
        >
          {{ $t('m.clearPortSeq') }}
        </v-btn>
      </template>
      <template v-else>
        <v-btn
          depressed
          color="primary"
          small
          @click="genPortRotation"
        >
          {{ $t('m.genPortSeq') }}
        </v-btn>
      </template>

      <v-btn
        depressed
        class="white--text ml-2"
        color="teal darken-1"
        @click="handlePortAdd"
        small
        :disabled="!isRotating || isGettedDistance"
      >
        {{ $t('m.addPort') }}
      </v-btn>

      <v-card
        class="ml-4 d-flex align-center"
        flat
        tile
      >
        <div class="font-weight-bold text-body-2">
          {{ $t('m.margin') }}
        </div>
        <div class="ml-3 mr-1 text-body-2">
          {{ $t('m.seaDaysShort') }}:
        </div>
        <v-text-field
          v-model="marginSeaDay"
          style="width:50px;"
          type="number"
          dense
          hide-details
          class="mb-2"
        />

        <div class="ml-3 mr-1 text-body-2">
          {{ $t('m.idleDaysShort') }}:
        </div>
        <v-text-field
          v-model="marginIdleDay"
          style="width:50px;"
          type="number"
          dense
          hide-details
          class="mb-2"
        />

        <div class="ml-3 mr-1 text-body-2">
          {{ $t('m.workDaysShort') }}:
        </div>
        <v-text-field
          v-model="marginWorkDay"
          style="width:50px;"
          type="number"
          dense
          hide-details
          class="mb-2"
        />
      </v-card>

      <v-card
        flat
        tile
        class="d-flex ml-6 align-center"
      >
        <v-btn
          depressed
          small
          class="white--text"
          :disabled="!isRotating || isGettedDistance"
          color="green darken-1"
          @click="getDistance"
        >
          {{ $t('m.getDis') }}
        </v-btn>
        <v-btn
          depressed
          small
          class="white--text ml-3"
          :disabled="!isGettedDistance"
          color="warning"
          @click="clearDistance"
        >
          {{ $t('m.clearDis') }}
        </v-btn>
      </v-card>
    </v-card>

    <v-snackbar
      v-model="snackbar"
      centered
    >
      {{ snackbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn
          color="pink"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          {{ $t('m.close') }}
        </v-btn>
      </template>
    </v-snackbar>

    <PortAddDlg
      :visible="portAddVisible"
      @cancel="cancelPortAdd"
      @save="handleAddPortSubmit"
      :target-port-arr="targetPortArr"
    />

    <DateAndTimeDlg
      :visible="dateAndTimeDlgVisible"
      :my-picker="myArrivedDate"
      :my-time-picker="myArrivedTime"
      @cancel="closeDateAndTimeDlg"
      @save="handleDateSelectSubmit"
    />

    <MapEditDialog
      :visible="mapEditDlgVisible"
      :esti-i-d="estiID"
      @cancel="cancelMapEditDlg"
    />

    <AlertConfirmDlg
      :visible="alertConfirmDlgVisible"
      :title="alertTitle"
      :content="alertContent"
      @cancel="cancelAlertDlg"
      @confirm="confirmAlertDlg"
    />
  </v-card>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import Utils from '@/utils/index'
import httpClient from '@/api/httpClient'
import Constant from '@/constant'
import dayjs from 'dayjs'
import PortAddDlg from './PortAddDlg'
import DateAndTimeDlg from './DateAndTimeDlg'
import EstiTmpl from '@/components/estimation/EstiTmpl'
import AlertConfirmDlg from '@/components/AlertConfirmDlg'
import MapEditDialog from './MapEditDialog'

export default {
  name: 'PortRotationForm',
  components: {
    PortAddDlg, DateAndTimeDlg, AlertConfirmDlg, MapEditDialog
  },
  props: [
    'model', 'visible'
  ],
  data () {
    return {
      snackbar: false,
      snackbarText: null,
      defalutBlankNum: 4,
      portsRotationArr: [],

      isShowWarning: false,
      portAddVisible: false,
      dateAndTimeDlgVisible: false,
      myArrivedDate: null,
      myArrivedDateDisplay: null,
      myArrivedTime: null,

      mapEditDlgVisible: false,

      searchResults: [],
      isCalingDistance: false,
      marginSeaDay: '',
      marginIdleDay: '',
      marginWorkDay: '',

      alertConfirmDlgVisible: false,
      alertWhich: null, // 1 - clear rotation  2 - clear distance
      alertTitle: '',
      alertContent: '',

      estiID: 0
    }
  },
  created () {
    this.genBlank()
    this.$store.commit('setIsGettedDistanceForEsti', false)
    this.$store.commit('setIsRotating', false)
  },
  computed: {
    ...mapState({
      isRotating: state => state.estimating.isRotating,
      isGettedDistance: state => state.estimating.isGettedDistance,
      editFlag: state => state.estimating.editFlag,
      resetMessage: state => state.estimating.resetMessage,
      clearFlag: state => state.estimating.clearFlag,
      shipInfo: state => state.estimating.shipInfo,
      useEca: state => state.estimating.useEca,

      SpeedType: state => state.estimating.shipInfo.SpeedType,
      SpeedBallast: state => state.estimating.shipInfo.SpeedBallast,
      SpeedLaden: state => state.estimating.shipInfo.SpeedLaden,

      isNeedCalAfterRebuild: state => state.estiDistance.isNeedCalAfterRebuild,
      isGettedDistanceFromMap: state => state.estiDistance.isGettedDistance,
      routeOnlyPorts: state => state.estiDistance.routeOnlyPorts
    }),
    ...mapGetters({
      ttlVoyDays: 'getTtlVoyDays',
      ttlSeaDays: 'getTtlSeaDays',
      ttlPortIdleDays: 'getTtlPortIdleDays',
      ttlPortWorkDays: 'getTtlPortWorkDays'
    }),
    targetPortArr () {
      var arr = []
      this.portsRotationArr.forEach((ele, index) => {
        if (ele.taskType !== '') {
          arr.push({
            portSeq: ele.portSeq,
            portId: ele.port.portId,
            name: ele.port.portName +
                  ' - ' + Constant.TASK_TYPE_MAP[ele.taskType]
          })
        }
      })
      return arr
    },
    upMoveVisible () {
      return this.isRotating && this.portsRotationArr.length > 2
    },
    downMoveVisible () {
      return this.isRotating && this.portsRotationArr.length > 2
    },

    openMapDisabled () {
      var isDisabled = false
      if (!this.isGettedDistance) {
        return true
      }
      for (let i = 1; i < this.portsRotationArr.length; i++) {
        var rotation = this.portsRotationArr[i]
        if (!rotation.port || !rotation.port.longitude ||
              !rotation.port.latitude) {
          isDisabled = true
          break
        }
      }
      return isDisabled
    }
  },
  watch: {
    model: function (val) {
      if (val) {
        this.estiID = val.ESTIID
        this.resetForm()
      } else {
        this.estiID = 0
        this.clearForm()
      }
    },
    clearFlag: function (val) {
      if (val) this.clearForm()
    },
    marginSeaDay: function (val) {
      this.$store.commit('setMarginSeaDay', val)
    },
    marginIdleDay: function (val) {
      this.$store.commit('setMarginIdleDay', val)
    },
    marginWorkDay: function (val) {
      this.$store.commit('setMarginWorkDay', val)
    },
    'shipInfo.ShipID': function (val) {
      if (this.isGettedDistance) {
        this.calSomeOfRotationArr()
        this.$store.commit('setPortsRotationArr', this.portsRotationArr)
      }
    },
    SpeedType: function (val) {
      if (this.isGettedDistance) {
        this.calSomeOfRotationArr()
        this.$store.commit('setPortsRotationArr', this.portsRotationArr)
      }
    },
    SpeedBallast: function (val) {
      if (this.isGettedDistance) {
        this.calSomeOfRotationArr()
        this.$store.commit('setPortsRotationArr', this.portsRotationArr)
      }
    },
    SpeedLaden: function (val) {
      if (this.isGettedDistance) {
        this.calSomeOfRotationArr()
        this.$store.commit('setPortsRotationArr', this.portsRotationArr)
      }
    },
    useEca: function (val) {
      if (!this.isGettedDistance) return
      this.getDistance()
    },

    isGettedDistanceFromMap: function (val) {
      if (val) {
        this.calDistance()
      }
    },

  },

  methods: {
    genBlank () {
      var arr = []; var tmpl
      for (var i = 0; i < this.defalutBlankNum; i++) {
        tmpl = this._.cloneDeep(EstiTmpl.PORT_ROTATION)
        tmpl.portSeq = i
        arr.push(tmpl)
      }
      this.portsRotationArr = arr
    },
    zeroRotation (rotation) {
      rotation.distance = 0
      rotation.ecaDistance = 0
      rotation.speed = 0
      rotation.seaDays = 0
      rotation.ecaSeaDays = 0
      rotation.idleDays = ''
      rotation.workDays = ''
      // rotation.portCharge = 0
    },
    zeroArrivedDeparted (rotation) {
      rotation.arrived = ''
      rotation.departed = ''
      rotation.arrivedDate = ''
      rotation.arrivedTime = ''
      rotation.departedDate = ''
      rotation.departedTime = ''

      this.myArrivedDate = null
      this.myArrivedDateDisplay = null
      this.myArrivedTime = null
    },

    handleFieldInput (val, index, name) {
      if (name === 'IDLEDAYS' || name === 'WORKDAYS') {
        if (this.isGettedDistance) {
          this.handleTimeChange()
        }
      }
      this.$store.commit('updatePortsRotationByIndex', {
        index: index, rotation: this.portsRotationArr[index]
      })
    },

    openMap () {
      this.mapEditDlgVisible = true
    },
    cancelMapEditDlg () {
      this.mapEditDlgVisible = false
    },

    openDateAndTimeDlg () {
      this.dateAndTimeDlgVisible = true
    },
    closeDateAndTimeDlg () {
      this.dateAndTimeDlgVisible = false
    },
    handleDateSelectSubmit (selected) {
      this.dateAndTimeDlgVisible = false
      this.myArrivedDate = selected.myArrivedDate
      this.myArrivedDateDisplay = dayjs(this.myArrivedDate).format('YY-MM-D')
      this.myArrivedTime = selected.myArrivedTime
      this.portsRotationArr[0].arrivedDate = selected.myArrivedDate
      this.portsRotationArr[0].arrivedTime = selected.myArrivedTime
      this.handleTimeChange()
    },
    clearArrivedTime () {
      this.portsRotationArr[0].arrived = ''
    },
    clearArrivedDate () {
      this.portsRotationArr[0].arrived = ''
    },

    cancelAlertDlg () {
      this.alertConfirmDlgVisible = false
    },
    confirmAlertDlg () {
      this.alertConfirmDlgVisible = false
      if (this.alertWhich == 1) {
        this.clearRotation()
      } else if (this.alertWhich == 2) { // clear 清除航程
        this.portsRotationArr.forEach((ele, index) => {
          this.zeroRotation(ele)
          this.zeroArrivedDeparted(ele)
        })
        this.$store.commit('setPortsRotationArr', this.portsRotationArr)
        this.$store.commit('setIsGettedDistanceForEsti', false)

        this.$store.commit('clearDistanceForEsti')
      }
    },

    clearRotation () {
      this.$store.commit('setIsRotating', false)
      this.$store.commit('setIsGettedDistanceForEsti', false)
      this.genBlank()

      this.marginSeaDay = ''
      this.marginIdleDay = ''
      this.marginWorkDay = ''
      this.myArrivedDate = null
      this.myArrivedDateDisplay = null
      this.myArrivedTime = null
      this.$store.commit('setPortsRotationArr', [])
    },
    removePortPad (index) { // 删除港口 没提交到vuex ????
      this.portsRotationArr.splice(index, 1)
      this.portsRotationArr.forEach((ele, index) => {
        if (ele.portSeq >= 0) {
          ele.portSeq = index
        }
      })
    },
    moveRow (index, direction) { // 也没提交vuex ?
      var _this = this
      this.portsRotationArr.forEach((ele, index) => {
        this.zeroArrivedDeparted(ele)
      })

      var srcRotation = this.portsRotationArr[index]
      if (direction === 'UP') {
        if (index == 0) return

        srcRotation.portSeq--
        this.portsRotationArr[index - 1].portSeq++
        this.portsRotationArr[index] = this.portsRotationArr
          .splice(index - 1, 1, srcRotation)[0]
      } else {
        if (index == this.portsRotationArr.length - 1) return

        srcRotation.portSeq++
        this.portsRotationArr[index + 1].portSeq--
        this.portsRotationArr[index] = this.portsRotationArr
          .splice(index + 1, 1, srcRotation)[0]
      }
    },

    genPortRotation () { // 生成港序
      if (this.isRotating) { // 已有港序
        if (this.isGettedDistance) {
          this.alertWhich = 1
          this.alertContent = this.$t('m.clearSeqConfirm')
          this.alertConfirmDlgVisible = true
        } else {
          this.clearRotation()
        }
      } else {
        var _this = this
        var cargos = this.$store.state.estimating.cargoTabsArr
        if (cargos.length == 0) {
          this.snackbarText = this.$t('m.inputCargoAndLD')
          this.snackbar = true
          return
        }

        var portIdStrArr = []
        for (var t = 0; t < cargos.length; t++) {
          var cargoEle = cargos[t]
          if (self._.trim(cargoEle.Cargo) === '' ||
                cargoEle.LoadPort.portId.length == 0 || cargoEle.DischargePort.portId.length == 0) {
            this.snackbarText = this.$t('m.inputCargoAndLD')
            this.snackbar = true
            return
          }
          /**
              if (portIdStrArr.includes(cargoEle.DischargePort.portId + ',' + cargoEle.DischargePort.portId)) {
                this.snackbarText = '有装卸港次序相反'
                this.snackbar = true
                return
              }
              **/
          portIdStrArr.push(cargoEle.LoadPort.portId + ',' + cargoEle.DischargePort.portId)
        }

        this.$store.commit('setIsRotating', true)
        var ports = []; var portSeq = 0; var loadingPorts = []; var dischargingPorts = []
        let i = 0
        for (const cargo of cargos) {
          // var cargo = cargos[i]
          if (loadingPorts.indexOf(cargo.LoadPort.portId) === -1) {
            var r_l = { } // 装货 workDays
            this.zeroRotation(r_l)
            r_l.portSeqInCargos = i
            r_l.portSeq = portSeq
            r_l.taskType = Constant.TASK_TYPE_LOADING
            r_l.taskTypeName = this.$t('m.taskLoading')
            r_l.port = Object.assign({}, cargo.LoadPort)
            r_l.workDays = ''
            loadingPorts.push(cargo.LoadPort.portId)
            ports.push(r_l)
            portSeq++
          }

          if (dischargingPorts.indexOf(cargo.DischargePort.portId) === -1) {
            var r_d = { }
            this.zeroRotation(r_d)
            r_d.portSeqInCargos = i
            r_d.portSeq = portSeq
            r_d.taskType = Constant.TASK_TYPE_DISCHARING
            r_d.taskTypeName = this.$t('m.taskDischarging')
            r_d.port = Object.assign({}, cargo.DischargePort)
            r_d.workDays = ''
            dischargingPorts.push(cargo.DischargePort.portId)
            ports.push(r_d)
            portSeq++
          }
          i++
        }
        this.portsRotationArr = ports
        this.$store.commit('setPortsRotationArr', this.portsRotationArr)
      } // end 产生港序
    },

    clearDistance () {
      if (this.isGettedDistance) {
        this.alertWhich = 2
        this.alertContent = this.$t('m.clearDisConfirm')
        this.alertConfirmDlgVisible = true
      }
    },

    getDistance () { // 获取航程 isGettedDistance 并提交到store
      var _this = this

      if (!this.portsRotationArr[0].arrivedDate || !this.portsRotationArr[0].arrivedTime) {
        this.snackbarText = this.$t('m.selectArrivedDate')
        this.snackbar = true
        return
      }
      /*
          if (this.portsRotationArr[0].taskType=='1'&&!this.portsRotationArr[0].departTime) {
            //this.showWarningMessage('请填写离港时间')
            return
          }
          */
      // 装卸港次序
      /*
          let loadRotationArr = []
          this.portsRotationArr.forEach((ele, index) => {
            if (ele.taskType==Constant.TASK_TYPE_LOADING)
              loadRotationArr.push(ele)
          })
          for (let i = 0; i < loadRotationArr.length; i++) {
            let ele = loadRotationArr[i]
            let disPortSeq = this.portsRotationArr
              .find(element => ele.portSeqInCargos==element.portSeqInCargos
                  && element.taskType==Constant.TASK_TYPE_DISCHARING).portSeq
            if (disPortSeq<ele.portSeq) {
              this.showWarningMessage('装卸港次序不正确')
              return
            }
          } */
      //this.$store.commit('setEstiIsGettedDistance', true)

      this.isCalingDistance = true
      var portIdArr = []
      this.portsRotationArr.forEach((ele, index) => {
        portIdArr.push(ele.port.portId)
      })

      /**
          var eacAreaArr = this.$store.state.distance.ecaAreas
          this.portsRotationArr.forEach((ele, index) => { // 是否eca
            if (ECAUtil.judgeInEca(eacAreaArr
                , { x: ele.port.longitude, y: ele.port.latitude }) ) {
              ele.port.inEca = '1' //
            }
          })  **/

      this.$store.dispatch('getDistanceForEstimating', { portIdStr: portIdArr.join(',') })
        /*.then((routeArr) => {
          this.calDistance()
          
          // 初始化
        }) // end*/
    }, // end getDistance

    calDistance () { // routeOnlyPorts
      this.$store.commit('setEstiIsGettedDistance', true)
      
      for (let j = 1; j < this.portsRotationArr.length; j++) {
        var onlyPort = this.routeOnlyPorts[j]
        var rotation = this.portsRotationArr[j]
        rotation.distance = this._.round(onlyPort.gVal, 2)
        rotation.ecaDistance = this._.round(onlyPort.ecaVal, 2)
      } // end rotation 赋值

      this.calSomeOfRotationArr()
      this.isCalingDistance = false

      

      
      // this.$store.commit("changeRouteFlag", false);
    },

    calSomeOfRotationArr () {
      var size = this.portsRotationArr.length
      for (var i = 1; i < size; i++) {
        var currRotation = this.portsRotationArr[i]
        if (this.portsRotationArr[i - 1].taskType == Constant.TASK_TYPE_BALLAST ||
              this.portsRotationArr[i - 1].taskType == Constant.TASK_TYPE_DISCHARING)
        // currRotation.speed = this.speedFlag=='1' ? this.shipInfo.ballastFullSpeed : this.shipInfo.ballastEcoSpeed
        { currRotation.speed = this._.toNumber(this.SpeedBallast) } else {
          currRotation.speed = this._.toNumber(this.SpeedLaden)
          // currRotation.speed = this.speedFlag=='1' ? this.shipInfo.ladenFullSpeed : this.shipInfo.ladenEcoSpeed
        }

        if (currRotation.speed > 0) {
          currRotation.ecaSeaDays = Math.round((currRotation.ecaDistance * 100) / (currRotation.speed * 24)) / 100
          currRotation.seaDays = this._.round((currRotation.distance * 100) / (currRotation.speed * 24) / 100, 2)
        } else {
          currRotation.ecaSeaDays = 0
          currRotation.seaDays = 0
        }
      } // end for
      this.handleTimeChange()
    },

    handleTimeChange () {
      if (!this.isGettedDistance) return

      var firstRotation = this.portsRotationArr[0]
      firstRotation.arrived = new Date(firstRotation.arrivedDate + ' ' + firstRotation.arrivedTime)
      firstRotation.departed = firstRotation.arrived.getTime() +
              (this._.toNumber(firstRotation.idleDays) + this._.toNumber(firstRotation.workDays)) *
                 24 * 3600 * 1000

      for (let j = 1; j < this.portsRotationArr.length; j++) {
        const r = this.portsRotationArr[j]
        const stayDays = this._.toNumber(r.idleDays) + this._.toNumber(r.workDays)

        r.arrived = (this._.isObject(this.portsRotationArr[j - 1].departed)
          ? this.portsRotationArr[j - 1].departed.getTime() : this.portsRotationArr[j - 1].departed) +
              this._.round(this.portsRotationArr[j].seaDays * 24 * 3600 * 1000)
        r.departed = r.arrived +
              this._.round(stayDays * 24 * 3600 * 1000)
      }

      this.$store.commit('setPortsRotationArr', this.portsRotationArr)
      this.$set(this.portsRotationArr, 0, this._.cloneDeep(firstRotation))
    },

    handlePortAdd () {
      this.portAddVisible = true
    },
    cancelPortAdd () {
      this.portAddVisible = false
    },
    handleAddPortSubmit (portAddForm) { // 添加港口
      this.portAddVisible = false
      var rotation = {}
      rotation.portSeqInCargos = -1
      rotation.taskType = portAddForm.taskType
      let taskStr = Constant.TASK_TYPE_MAP[rotation.taskType]
      taskStr = taskStr[0].toUpperCase() + taskStr.substring(1)
      rotation.taskTypeName = this.$t('m.task'+taskStr)

      rotation.port = {
        portId: portAddForm.portId,
        portName: portAddForm.portName,
        fullName: portAddForm.fullName,
        longitude: portAddForm.longitude,
        latitude: portAddForm.latitude
      }
      this.zeroRotation(rotation)

      if (portAddForm.posType == 1) { // 上方
        if (portAddForm.targetPortPos === 0) {
          rotation.portSeq = 0
        } else {
          rotation.portSeq = portAddForm.targetPortPos - 1
        }
        this.portsRotationArr.splice(portAddForm.targetPortPos, 0, rotation)
      } else {
        this.portsRotationArr.splice(portAddForm.targetPortPos + 1, 0, rotation)
      }

      this.portsRotationArr.forEach((ele, index) => {
        ele.portSeq = index
      })
      this.$store.commit('setPortsRotationArr', this.portsRotationArr)
    },

    clearForm () {
      this.genBlank()
      this.$store.commit('setPortsRotationArr', [])

      this.myArrivedDate = null
      this.myArrivedDateDisplay = null
      this.myArrivedTime = null,

      this.marginSeaDay = 0
      this.marginIdleDay = 0
      this.marginWorkDay = 0

      this.$store.commit('setIsRotating', false)
      this.$store.commit('setIsGettedDistance', false)

      var ttlVoyInfo = {}
      ttlVoyInfo.ttlVoyDays = 0
      ttlVoyInfo.ttlSeaDays = 0
      ttlVoyInfo.ttlPortIdleDays = 0
      ttlVoyInfo.ttlPortWorkDays = 0
      this.$store.commit('setTtlVoyInfo', ttlVoyInfo)
    },

    resetForm () {
      var portData = this.model.ESTICONTENT.portData
      this.marginSeaDay = portData.marginSeaDays
      this.marginIdleDay = portData.marginIdleDays
      this.marginWorkDay = portData.marginWorkDays

      var arr = []
      portData.portOrder.forEach((ele, index) => {
        var rotation = this._.cloneDeep(EstiTmpl.PORT_ROTATION)
        rotation.portSeqInCargos = _.toNumber(ele.cargoUid)
        rotation.portSeq = ele.no
        rotation.taskType = ele.TaskType + ''
        if (ele.TaskTypeName) {
          rotation.taskTypeName = ele.TaskTypeName
        } else { rotation.taskTypeName = ele.taskTypeName }

        rotation.port = {
          portId: ele.PortID,
          fullName: ele.PortName,
          portName: ele.PortName.indexOf(',') != -1 ? ele.PortName.split(',')[0] : ele.PortName,
          longitude: ele.PortLon,
          latitude: ele.PortLat
        }
        if (ele.PortLon && ele.PortLat &&
              _.isNumber(ele.PortLon) && _.isNumber(ele.PortLat)) {
          rotation.port.longitude = ele.PortLon
          rotation.port.latitude = ele.PortLat
        } else {
          rotation.port.longitude = ele.lon
          rotation.port.latitude = ele.lat
        }

        rotation.portCharge = ele.PortCharge
        rotation.distance = ele.Distance
        rotation.seaDays = ele.SeaDays
        rotation.idleDays = ele.PortIdleDays
        rotation.workDays = ele.PortWorkDays
        if (ele.ArrivalDate) {
          if (index == 0) {
            rotation.arrived = ele.ArrivalDate
            rotation.arrivedDate = dayjs(ele.ArrivalDate).format('YYYY-MM-DD')
            rotation.arrivedTime = dayjs(ele.ArrivalDate).format('HH:mm')

            this.myArrivedDate = rotation.arrivedDate
            this.myArrivedDateDisplay = dayjs(ele.ArrivalDate).format('YY-MM-DD')
            this.myArrivedTime = rotation.arrivedTime
          } else {
            rotation.arrived = ele.ArrivalDate
          }
        } else { rotation.arrived = '' }

        rotation.departed = ele.DepartureDate ? ele.DepartureDate : ''

        arr.push(rotation)
      })

      if (_.toNumber(portData.portOrder[1].Distance) > 0) { 
        this.$store.commit('setIsGettedDistance', true) 
      } else { 
        this.$store.commit('setIsGettedDistance', false) 
      }

      this.portsRotationArr = arr
      this.$store.commit('setPortsRotationArr', this.portsRotationArr)
      // txtTTLDays
      this.$store.commit('setIsRotating', true)

      // one more thing 航线数据 originRoutes

      if (this.model.ESTICONTENT.routePoints &&
            this.model.ESTICONTENT.routePoints.length > 0) {
        const portPointArr = []
        const requiredWayPointArr = []
        let routeSeq = 0
        this.model.ESTICONTENT.routePoints.forEach((ele, index) => {
          ele.route.forEach((e, i) => {
            if ((e.wt === '0' || e.wt === '2') &&
                   portPointArr.findIndex(element => element.PortID === e.wc) == -1) {
              var o = {}
              o.PortID = e.wc
              o.PortName = e.wn
              o.FullName = e.wn
              o.lon = e.lon
              o.lat = e.lat
              if (e.wt === '2') {
                o.isWayPoint = true
              }
              portPointArr.push(o)

              if (e.wt === '2') {
                var requiredWayPoint = {}
                requiredWayPoint.PortID = e.wc
                requiredWayPoint.PortName = e.wn
                requiredWayPoint.isWayPoint = true
                requiredWayPointArr.push(requiredWayPoint)
              }
            }

            e.routeSeq = routeSeq
            routeSeq++
          })
        })

        this.$store.commit('setPortPointArrEsti', portPointArr)
        this.$store.commit('setOriginPortPointArrEsti', portPointArr)

        this.$store.commit('setOriginRoutesEsti', this.model.ESTICONTENT.routePoints)
        this.$store.commit('setPreservedOriginRoutes', this.model.ESTICONTENT.routePoints)

        this.$store.commit('setRequiredWayPointEsti', requiredWayPointArr)
        this.$store.commit('setOriginRequiredWayPointArr', requiredWayPointArr)
        this.$store.dispatch('reBuildRoutesForEsti')
      } else { // 没有产生航线数据
        const portPointArr = []
        this.portsRotationArr.forEach((ele, index) => {
          var o = {}
          o.PortID = ele.port.portId
          o.PortName = ele.port.fullName
          o.FullName = ele.port.portName
          o.lon = ele.port.longitude
          o.lat = ele.port.latitude
          portPointArr.push(o)
        })
        this.$store.commit('setPortPointArrEsti', portPointArr)
        this.$store.commit('setOriginPortPointArrEsti', portPointArr)
      }
    } // end reset

  },

  filters: {
    timFormat: function (val) {
      if (!val) return ''
      return dayjs(val).format('YY-MM-D HH:mm')
    }
  }
}
</script>

<style scoped>
  .my-simple-table {
    border-top: 1px solid rgba(0, 0, 0, .2);
    border-bottom: 1px solid rgba(0, 0, 0, .2);
  }
  .my-simple-table th, .my-simple-table td {
    border-right: thin solid rgba(0, 0, 0, .12);
    padding-left: 12px !important; padding-right: 12px !important;
    text-align: center;
  }
  .my-simple-table th:last-child, .my-simple-table td:last-child {
    border-right: none;
  }
</style>
